import type { CSSProperties } from "react";

// "Organic" brand palette (2026-08-12) - matches the mobile app's terracotta/
// sage/cream direction (mobile/travelstory-mobile/src/constants/theme.ts),
// replacing the original generic blue/purple placeholder palette. Every
// value here is contrast-checked (WCAG AA, >=4.5:1) against both cardBg and
// pageBg for its intended use as text - see conversation history for the
// exact numbers if these ever need revisiting.
export const colors = {
  accentStart: "#8A5730",
  accentEnd: "#5C6A42",
  gradient: "linear-gradient(135deg, #8A5730, #5C6A42)",
  textPrimary: "#211D18",
  textSecondary: "#6B5F4F",
  border: "#D8C7A8",
  cardBg: "#FBF7EF",
  pageBg: "#F1E7D6",
  error: "#A13E28",
};

export const radius = {
  sm: "8px",
  md: "12px",
  lg: "16px",
  pill: "999px",
};

export const shadow = {
  card: "0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.04)",
  cardHover: "0 8px 24px rgba(138,87,48,0.16)",
};

export const buttonPrimary: CSSProperties = {
  background: colors.gradient,
  color: "#fff",
  border: "none",
  borderRadius: radius.md,
  padding: "10px 20px",
  fontWeight: 600,
  fontSize: "14px",
  cursor: "pointer",
  textDecoration: "none",
  display: "inline-block",
};

export const buttonSecondary: CSSProperties = {
  background: colors.cardBg,
  color: colors.textPrimary,
  border: `1px solid ${colors.border}`,
  borderRadius: radius.md,
  padding: "10px 20px",
  fontWeight: 600,
  fontSize: "14px",
  cursor: "pointer",
  textDecoration: "none",
  display: "inline-block",
};

export const card: CSSProperties = {
  background: colors.cardBg,
  border: `1px solid ${colors.border}`,
  borderRadius: radius.lg,
  boxShadow: shadow.card,
  padding: "20px",
};

export const input: CSSProperties = {
  width: "100%",
  padding: "10px 12px",
  borderRadius: radius.sm,
  border: `1px solid ${colors.border}`,
  fontSize: "16px",
  outline: "none",
};

export const pageContainer: CSSProperties = {
  maxWidth: "1000px",
  margin: "40px auto",
  padding: "20px",
  width: "100%",
};

export const navHeightPx = 56;
export const navHeight = `${navHeightPx}px`;

export const heroBackground: CSSProperties = {
  minHeight: "100vh",
  backgroundColor: colors.pageBg,
  backgroundImage:
    "linear-gradient(rgba(241,231,214,0.6), rgba(241,231,214,0.6)), url('/images/world-map-bg.webp')",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
};
